<app-steps [step]='1'></app-steps>

<form [formGroup]="registerFormGroup" autocomplete="off" class="needs-validation" (ngSubmit)="register()">
    <div class="card">
        <div class="card-body">
            <div class="row">
                <div class="col">
                    <h3 class="main-title card-title">
                        Register<br>
                        <small>
                            All fields marked with an asterisk (*) are required.
                        </small>
                    </h3>
                </div>
            </div>


            <div class="row">
                <div class="col">
                    <h4>Personal Information</h4>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>First Name*</mat-label>
                        <input matInput formControlName="firstName" type="text">
                        <mat-error *ngIf="formGroup.firstName.touched && formGroup.firstName.errors ">
                            {{formControlErrorMessage('firstName')}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Last Name*</mat-label>
                        <input matInput formControlName="lastName" type="text">
                        <mat-error *ngIf="formGroup.lastName.touched && formGroup.lastName.errors ">
                            {{formControlErrorMessage('lastName')}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Date of Birth</mat-label>
                        <input matInput [matDatepicker]="dateOfBirth" formControlName="dateOfBirth">
                        <mat-datepicker-toggle matSuffix [for]="dateOfBirth"></mat-datepicker-toggle>
                        <mat-datepicker touchUi #dateOfBirth></mat-datepicker>
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Gender at Birth</mat-label>
                        <mat-select formControlName="gender">
                            <mat-option *ngFor="let gender of genders" [value]="gender.value">
                                {{gender.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Do you have an Australian No.?</mat-label>
                        <mat-select formControlName="isAustralianPhoneNumber"
                            (selectionChange)="formGroup.mobilePhoneNumber.setValue('');">
                            <mat-option *ngFor="let gender of yesNo" [value]="gender.value">
                                {{gender.viewValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Mobile Phone*</mat-label>
                        <input matInput formControlName="mobilePhoneNumber" type="text"
                            [maxLength]="formGroup.isAustralianPhoneNumber!=null && formGroup.isAustralianPhoneNumber.value ? 11:100">
                        <mat-error *ngIf="formGroup.mobilePhoneNumber.touched && formGroup.mobilePhoneNumber.errors ">
                            {{formControlErrorMessage('mobilePhoneNumber')}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <mat-form-field appearance="outline">
                        <mat-label>Health Fund</mat-label>
                        <mat-select formControlName="healthFundId">
                            <mat-option *ngFor="let item of healthFunds" [value]="item.healthFundId">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>


            <div class="row">
                <div class="col">
                    <h4>
                        Address<br>
                        <small [innerHTML]="app.config.popUpDialogOnAddressClickMessage"></small>
                    </h4>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Address 1*</mat-label>
                        <input matInput formControlName="address1" (click)="showAddressNotification()" type="text" (keypress)="onAddress1Change($event.target.value)">
                        <mat-error *ngIf="formGroup.address1.touched && formGroup.address1.errors ">
                            {{formControlErrorMessage('address1')}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>State*</mat-label>
                        <mat-select formControlName="stateId">
                            <mat-option *ngFor="let item of states" (click)="onStateOptionClicked(item)"
                                [value]="item.stateId">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Suburb*</mat-label>
                        <mat-select formControlName="address4">
                            <mat-option *ngFor="let item of selectedState.suburbs" (click)="onSuburbOptionClicked(item)"
                                [value]="item.name">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-6 d-none">
                    <mat-form-field appearance="outline">
                        <mat-label>Suburb*</mat-label>
                        <input matInput type="text" autocomplete="off" formControlName="address4" [matAutocomplete]="suburbAuto" (input)="filterSuburb($event.target.value)">
                        <mat-autocomplete #suburbAuto="matAutocomplete">
                            <cdk-virtual-scroll-viewport itemSize="15" minBufferPx="240" maxBufferPx="720"
                                [ngStyle]="{'height.px': filteredSuburbs?.length < 10 ? filteredSuburbs?.length * 48 : 48*4 }">
                                <mat-option (click)="onSuburbOptionClicked(suburb)" *cdkVirtualFor="let suburb of filteredSuburbs; templateCacheSize: 50" [value]="suburb.name">
                                    {{suburb.name}}
                                </mat-option>
                            </cdk-virtual-scroll-viewport>
                        </mat-autocomplete>
                        <mat-error>{{formControlErrorMessage('address4')}}</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Postcode*</mat-label>
                        <input matInput formControlName="postCode" type="text">
                        <mat-error *ngIf="formGroup.postCode.touched && formGroup.postCode.errors ">
                            {{formControlErrorMessage('postCode')}}</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Country*</mat-label>
                        <mat-select formControlName="countryId">
                            <mat-option *ngFor="let item of countries" [value]="item.countryId">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <h4>Login Information</h4>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <mat-form-field appearance="outline">
                        <mat-label>E-mail*</mat-label>
                        <input matInput formControlName="email" type="text">
                        <mat-error *ngIf="formGroup.email.touched && formGroup.email.errors ">
                            {{formControlErrorMessage('email')}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <mat-form-field appearance="outline">
                        <mat-label>Confirm Email*</mat-label>
                        <input matInput formControlName="confirmEmail" type="text">
                        <mat-error *ngIf="formGroup.confirmEmail.touched && formGroup.confirmEmail.errors ">
                            {{formControlErrorMessage('confirmEmail')}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <mat-form-field appearance="outline">
                        <mat-label>Password*</mat-label>
                        <input matInput formControlName="password" type="password">
                        <mat-error *ngIf="formGroup.password.touched && formGroup.password.errors ">
                            {{formControlErrorMessage('password')}}</mat-error>
                    </mat-form-field>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <mat-form-field appearance="outline">
                        <mat-label>Confirm Password*</mat-label>
                        <input matInput formControlName="confirmPassword" type="password">
                        <mat-error *ngIf="formGroup.confirmPassword.touched && formGroup.confirmPassword.errors">
                            {{formControlErrorMessage('confirmPassword', 0, 6)}}</mat-error>
                        <mat-error
                            *ngIf="formGroup.confirmPassword.errors != null ? formGroup.confirmPassword.errors.mustMatch : false">
                            Password and confirm password must match
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <mat-checkbox formControlName="acceptTerms">
                        I've read and agree to the <a style="cursor: pointer; color: #009CDE;"
                        (click)="openTerms()" targe="_blank">Terms and Conditions</a>
                    </mat-checkbox>
                    <div *ngIf="formGroup.acceptTerms.touched && formGroup.acceptTerms.errors" class="invalid-feedback">
                        Agree to the Terms & Conditions is required
                    </div>
                </div>
            </div>
        </div>

        <div class="card-footer text-center">
            <button class="btn btn-blue" type="submit">Register</button>
            <a class="btn btn-secondary" [routerLink]="['/customer/login']">Already a patient? Back to login</a>
        </div>
    </div>
</form>